import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import { useState } from 'react';
import { connect } from 'react-redux';
import { saveFields, resetFields } from 'Store/FieldManagement/Actions';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import EntityField from './EntityField';
import FieldAdd from './Field/FieldAdd';

const FieldEntity = ({fields, entity, ...props}: any) => {
    const [isAdd, setAdd] = useState(false);

    return <>
        {fields && fields.saved?.filter((item) => item?.type !== FieldType.Predefined).map((item: any, key: number) => (
            <EntityField
                key={key}
                entity={entity}
                id={item.id}
                name={item.name}
                type={item.type}
                default={item.default}
                required={item.required}
                status={item.status} />
        ))}

        { isAdd && <FieldAdd entity={entity} cancel={() => setAdd(false)}/> }
        { !isAdd && <AddNew onClick={() => setAdd(true)}>+ Field toevoegen</AddNew> }
    </>
}

export default connect(
    () => ({}),
    {
        saveFields,
        resetFields
    }
)(FieldEntity);